module.exports = __webpack_public_path__ + "img/blend4icon2.9f17c5a5.png";